import React from "react";
import { BrowserRouter } from "react-router-dom";
import Routes from "./Routes";
import "./App.css";
import UserContextProvider from "./context/UserContext";
function App() {
  return (
    <UserContextProvider>
      <BrowserRouter>
        <Routes></Routes>
      </BrowserRouter>
    </UserContextProvider>
  );
}

export default App;
